<script>
export default {
  props: {
    selectedOption: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      options: ['yes', 'somewhat', 'not_really'],
    };
  },
  methods: {
    onOptionSelected(option) {
      this.$emit('option-selected', option);
    },
  },
};
</script>

<template>
  <transition name="expand" appear>
    <div class="pricing-bot-rating d-flex flex-column align-items-center p-32">
      <div>
        <p class="text-center mb-24">{{ $t('bot.rating.title') }}</p>
        <div
          v-for="(option, index) in options"
          :key="`rating-option-${option}`"
          :class="{
            'mt-16': index > 0,
            active: selectedOption === option,
            inactive: !!selectedOption && selectedOption !== option,
          }"
          class="rating-option bg-mobile-background d-flex flex-row align-items-center gap-16 py-8 px-16 rounded-border-8 clickable"
          @click="onOptionSelected(option)"
        >
          <img
            :alt="option"
            :src="require(`images/price_bot/rating/${option}.svg`)"
            height="32"
            width="32"
          />
          <p>{{ $t(`bot.rating.options.${option}`) }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>
